import React from 'react';

import Box from '@mui/material/Box';
import Fade from '@mui/material/Fade';

import LoadingDisplay from './LoadingDisplay';

interface LoadingWrapperProps {
  isLoading: boolean;
  children?: React.ReactNode;
  message?: string;
}

const LoadingWrapper: React.FC<LoadingWrapperProps> = (props) => {
  let { isLoading, children, message = 'Loading...' } = props;

  return (
    <Box sx={{ position: 'relative' }}>
      <Fade in={isLoading} timeout={300} unmountOnExit>
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            zIndex: 1,
          }}
        >
          <LoadingDisplay message={message} />
        </Box>
      </Fade>
      <Fade in={!isLoading} timeout={600}>
        <Box>{children}</Box>
      </Fade>
    </Box>
  );
};

export default LoadingWrapper;
